/**
 * @file        src/pages/account/CorporateReports.jsx
 * @description Account Management → Corporate Reports. The same wallet / gateway
 *              / refunds report set as the B2C Reports screen (Reports.jsx),
 *              fixed to audience=b2b, instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-09-15
 * @changelog
 *   - 2026-09-15 Claude — Initial. Splits the single Reports screen (which had a
 *                          "Customer type" picker including "All (B2C + B2B)")
 *                          into two audience-separated screens, matching how
 *                          every other B2C/Corporate pair in this console works.
 */
import Reports from './Reports';

export default function CorporateReports() {
  return (
    <Reports
      title="Corporate Reports"
      subtitle="Account Management · B2B wallet, gateway, refunds & cancellations"
      audience="b2b"
    />
  );
}
